import { render } from "./ItemsLocations.vue?vue&type=template&id=06984e26&scoped=true&ts=true"
import script from "./ItemsLocations.vue?vue&type=script&lang=ts"
export * from "./ItemsLocations.vue?vue&type=script&lang=ts"

import "./ItemsLocations.vue?vue&type=style&index=0&id=06984e26&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06984e26"]])

export default __exports__